import { action } from 'satcheljs';
import type MeetingMessage from 'owa-service/lib/contract/MeetingMessage';

export interface DeleteMeetingMessageActionMessage {
    item: MeetingMessage;
    issueDeleteItemCall: boolean | undefined;
}
const defaultExport: (
    item: MeetingMessage,
    issueDeleteItemCall?: boolean
) => DeleteMeetingMessageActionMessage = action(
    'deleteMeetingMessage',
    (item: MeetingMessage, issueDeleteItemCall?: boolean): DeleteMeetingMessageActionMessage => ({
        item,
        issueDeleteItemCall,
    })
);
export default defaultExport;
